import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SettingsService } from '../../common/settings.service';
import { LocalStorageService } from '../../common/localStorage.service';

const STORAGE_KEY = 'USER_COOKIE_SETTINGS';

export interface CookieSettings {
  firstParty: boolean;
  googleAnalytics: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  private _showPopup = new BehaviorSubject(false);
  showPopup$ = this._showPopup.asObservable();

  private _hasAgreedToGa = new BehaviorSubject(false);
  hasAgreedToGa$ = this._hasAgreedToGa.asObservable();

  constructor(
    private settingsService: SettingsService,
    private localStorageService: LocalStorageService
  ) {}

  init() {
    if (!this.settingsService.settings.preview && environment.COOKIE_CONSENT) {
      if (!this.hasChosenPreferences()) {
        setTimeout(() => {
          this.showPopup();
        }, 5000);
      } else {
        const cookiePref = this.getCookieUserSettings();
        this._hasAgreedToGa.next(cookiePref?.googleAnalytics);
      }
    } else {
      this._hasAgreedToGa.next(true); // forces true
    }
  }

  showPopup() {
    this._showPopup.next(true);
  }

  hidePopup() {
    this._showPopup.next(false);
  }

  hasChosenPreferences() {
    const settings = this.getCookieUserSettings();
    return !!settings;
  }

  acceptAll() {
    const cookieSettings = {
      firstParty: true,
      googleAnalytics: true,
    } as CookieSettings;
    this.saveCookieUserSettings(cookieSettings);
  }

  getCookieUserSettings() {
    const sJson = this.localStorageService.getItem(STORAGE_KEY);
    return JSON.parse(sJson);
  }

  saveCookieUserSettings(cookieSettings: CookieSettings) {
    this.localStorageService.setItem(
      STORAGE_KEY,
      JSON.stringify(cookieSettings)
    );
    this._hasAgreedToGa.next(cookieSettings.googleAnalytics);
  }
}
